import {
  Divider,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';

import { IcArrowLeft } from '@/assets/images';
import { SideModal } from '@/components';
import { EmergencyContactForm } from '@/layouts/TabLayout/MasterNames/components/EmergencyContactForm';
import { IEmergencyContact } from '@/models';

interface EmergencyContactSideModalProps {
  isDrawerOpen: boolean;
  setDrawerOpen: (shouldClose: boolean) => void;
  emergencyContact?: IEmergencyContact;
}

export const EmergencyContactSideModal = ({
  isDrawerOpen,
  setDrawerOpen,
  emergencyContact,
}: EmergencyContactSideModalProps) => {
  const handleClose = () => {
    setDrawerOpen(false);
  };

  const theme = useTheme();

  return (
    <SideModal open={isDrawerOpen} onClose={handleClose} closingType="none">
      <Stack
        sx={{
          backgroundColor: theme.palette.background.paper,
          height: '100%',
          padding: '20px',
        }}
      >
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: '20px',
          }}
        >
          <IconButton className="btnBack" onClick={handleClose}>
            <IcArrowLeft />
          </IconButton>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 600,
              fontSize: '1.5rem',
              lineHeight: '24px',
            }}
          >
            Add emergency contact
          </Typography>
        </Stack>
        <Divider />

        <EmergencyContactForm
          onClose={handleClose}
          currentEmergencyContact={emergencyContact}
        />
      </Stack>
    </SideModal>
  );
};
